import React, { useEffect, useRef, useState } from "react";
import useVersion from "@/hooks/useVersion";

const LogoWhite = "/img/Logo_White.svg";
const COUNTDOWN_SECONDS = 60;

export default function NewVersionBanner() {
  const { showReloadModal, resetModal } = useVersion();
  const [secondsLeft, setSecondsLeft] = useState(COUNTDOWN_SECONDS);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (!showReloadModal) {
      setSecondsLeft(COUNTDOWN_SECONDS);
      if (intervalRef.current) clearInterval(intervalRef.current);
      return;
    }

    setSecondsLeft(COUNTDOWN_SECONDS);
    intervalRef.current = setInterval(() => {
      setSecondsLeft(prev => {
        if (prev <= 1) {
          clearInterval(intervalRef.current!);
          window.location.reload();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => { if (intervalRef.current) clearInterval(intervalRef.current); };
  }, [showReloadModal]);

  if (!showReloadModal) return null;

  return (
    <div className="fixed flex -translate-x-1/2 left-1/2 top-10 z-50 w-80 rounded-xl shadow-2xl overflow-hidden">
      <div className="w-full">
        <div className="animate-gradient-roll-admin p-5 flex flex-col items-center gap-3">
          <img className="h-10 w-10 drop-shadow-lg" src={LogoWhite} alt="Velaro Logo" />
          <p className="text-white font-semibold text-base text-center leading-snug drop-shadow">
            Admin update is ready!
          </p>
        </div>

        <div className="bg-white px-5 pt-4 pb-5 flex flex-col gap-4">
          <p className="text-xs text-zinc-500 text-center">
            Refresh when you&apos;re at a good stopping point — your work
            won&apos;t be lost.
          </p>

          <div className="flex gap-2">
            <button
              onClick={resetModal}
              className="flex-1 text-xs px-3 py-2 rounded-lg border border-zinc-200 text-zinc-500 hover:bg-zinc-50 transition-colors"
            >
              Dismiss
            </button>
            <button
              onClick={() => window.location.reload()}
              className="flex-1 text-xs px-3 py-2 rounded-lg bg-violet-600 hover:bg-violet-700 text-white font-medium transition-colors"
            >
              Refresh Now ({secondsLeft}s)
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
